module.exports = __webpack_public_path__ + "img/bookmark-heart-fill.10ef8449.svg";